class DetailsModalSeperated extends DetailsModal {
    constructor() {
        super();
    }
    openManually() {
        this.detailsContainer.setAttribute('open', true);
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add('overflow-hidden');

        trapFocus(
            this.detailsContainer.querySelector('[tabindex="-1"]'),
            this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
    }

}

customElements.define('details-modal-seperated', DetailsModalSeperated);
